import React, { Suspense } from "react"
import PropTypes from "prop-types"
import { useQuery } from "lib/graphql"
import TopbarViewerActions from "components/TopbarViewerActions"
import { isSessionActive } from "lib/currentUser/session"

const AccountMenu = React.lazy(() => import("components/AccountMenu"))

export const VIEWER_QUERY = `
  query ($path: String!) {
    viewer {
      role
      user {
        id
        avatar
        name
        newsFeedCount
        commentNotificationCount
        allow {
          analytics
          moderateComments
        }
      }
    }
    adminActions (path: $path) { icon, label, path, trackAction }
  }
`

const AuthenticatedTopbarContent = ({ path }) => {
  const { loading, error, data } = useQuery(VIEWER_QUERY, {
    variables: { path },
  })

  if (loading || error) {
    return null
  }

  const adminActions = data.adminActions
  const role = data.viewer.role
  const user = data.viewer.user

  return (
    <Suspense fallback={null}>
      <AccountMenu adminActions={adminActions} userRole={role} user={user} />
      <TopbarViewerActions adminActions={adminActions} userRole={role} user={user} />
    </Suspense>
  )
}

AuthenticatedTopbarContent.propTypes = {
  path: PropTypes.string.isRequired,
}

const TopbarDynamicContent = ({ path }) => {
  if (!isSessionActive()) {
    return <TopbarViewerActions />
  }

  return <AuthenticatedTopbarContent path={path} />
}

TopbarDynamicContent.propTypes = {
  path: PropTypes.string.isRequired,
}

export default TopbarDynamicContent
